import { z } from 'zod'
import { oc } from '@orpc/contract'
import { REFERRAL_SPECIALTY_CODES } from '../referral-specialties.schema'
import { latSchema, lonSchema, referralLocationSchema } from './referral-discovery-views.schema'

// Query-string transport: numbers arrive as strings, hence the coercing lat/lon.
export const referralDiscoveryNearbyInputSchema = z
  .object({
    lat: latSchema,
    lon: lonSchema,
    radiusMiles: z.coerce
      .number()
      .pipe(z.union([z.literal(25), z.literal(50)]))
      .default(25),
    specialtyCode: z.enum(REFERRAL_SPECIALTY_CODES),
    query: z.string().trim().max(120).optional(),
    // 'state' searches the patient's whole state by clinic name instead of a radius.
    scope: z.enum(['radius', 'state']).default('radius'),
    state: z.string().length(2).toUpperCase().optional(),
  })
  .refine((v) => v.scope !== 'state' || Boolean(v.state), {
    message: 'state is required for a state-wide search',
    path: ['state'],
  })
  .refine((v) => v.scope !== 'state' || (v.query?.length ?? 0) >= 2, {
    message: 'a clinic name of at least 2 characters is required for a state-wide search',
    path: ['query'],
  })

export const referralDiscoveryNearby = oc
  .route({ method: 'GET', path: '/v2/referral-discovery/nearby' })
  .input(referralDiscoveryNearbyInputSchema)
  .output(
    z.object({
      locations: z.array(referralLocationSchema),
      source: z.enum(['google', 'unavailable']),
    }),
  )
